// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"8":"editor","419":"wiki","467":"download","603":"sponsor","623":"tree","671":"verbose"}[chunkId] || chunkId) + "." + {"8":"e27abaa4","419":"49bff36e","467":"9d448cfa","603":"9fe55dd0","623":"4161b305","671":"cc15df1d","678":"44d031d5"}[chunkId] + ".css";
};